var React = require('react');

function IconThreeDots (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 0C3.10457 0 4 0.895431 4 2C4 3.10457 3.10457 4 2 4C0.895431 4 0 3.10457 0 2C0 0.895431 0.895431 0 2 0ZM16 0C17.1046 0 18 0.895431 18 2C18 3.10457 17.1046 4 16 4C14.8954 4 14 3.10457 14 2C14 0.895431 14.8954 0 16 0ZM32 2C32 0.895431 31.1046 0 30 0C28.8954 0 28 0.895431 28 2C28 3.10457 28.8954 4 30 4C31.1046 4 32 3.10457 32 2Z","fill":"#142B6F"}));
}

IconThreeDots.defaultProps = {"width":"32","height":"4","viewBox":"0 0 32 4","fill":"none"};

module.exports = IconThreeDots;

IconThreeDots.default = IconThreeDots;
